<p-toast key="{{ messageKey }}"></p-toast>

<!-- Page header -->
<div *transloco="let t" class="pwc-linear-gradient px-8 pt-6 pb-14">
  <div class="flex items-center justify-between">
    <h1 class="text-white font-serif font-extralight text-3xl tracking-wide">
      {{ t("page_transaction_query_status") }}
    </h1>
    <button
      (click)="refresh()"
      class="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 text-white text-sm font-medium rounded-lg border border-white/20 transition-all duration-200"
    >
      <span class="icon-refresh-fill text-sm"></span>
      {{ t("refresh") }}
    </button>
  </div>
</div>

<div class="px-8 pb-10 -mt-8" *transloco="let t">
  <div class="bg-white rounded-xl shadow-lg overflow-hidden">
    <!-- Search bar -->
    <div
      class="px-5 py-3.5 border-b border-grey-light flex items-center justify-between"
    >
      <div class="flex items-center gap-2">
        <span class="icon-time-fill text-grey-default text-sm"></span>
        <span class="text-grey-dark font-medium text-sm">{{
          t("page_transaction_query_status")
        }}</span>
        <span
          *ngIf="queryEntries.length > 0"
          class="ml-2 px-2 py-0.5 text-xs font-semibold bg-orange-light2 text-orange-default rounded-full"
          >{{ queryEntries.length }}</span
        >
      </div>
      <p-iconfield>
        <input
          pInputText
          type="text"
          maxlength="32"
          #globalFilterInput
          (input)="queryTable.filterGlobal(globalFilterInput.value, 'contains')"
          [placeholder]="t('search')"
          class="w-64 text-sm border border-grey-light rounded-lg px-3 py-1.5"
        />
        <p-inputicon class="icon-search-outline text-grey-default" />
      </p-iconfield>
    </div>

    <!-- Table -->
    <div class="p-5">
      <p-table
        #queryTable
        [value]="queryEntries"
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [globalFilterFields]="[
          'engagementName',
          'jobCode',
          'vatNumber',
          'iban',
          'status',
        ]"
        sortField="created"
        [sortOrder]="-1"
        styleClass="p-datatable-sm"
        dataKey="id"
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="engagementName" class="text-xs uppercase">
              {{ t("name") }}
              <p-sortIcon field="engagementName"></p-sortIcon>
            </th>
            <th pSortableColumn="jobCode" class="text-xs uppercase">
              {{ t("jobcode") }}
              <p-sortIcon field="jobCode"></p-sortIcon>
            </th>
            <th pSortableColumn="vatNumber" class="text-xs uppercase">
              {{ t("vatnumber") }}
              <p-sortIcon field="vatNumber"></p-sortIcon>
            </th>
            <th pSortableColumn="iban" class="text-xs uppercase">
              IBAN
              <p-sortIcon field="iban"></p-sortIcon>
            </th>
            <th class="text-xs uppercase text-center">
              {{ t("selected_reports") }}
            </th>
            <th pSortableColumn="status" class="text-xs uppercase">
              {{ t("status") }}
              <p-sortIcon field="status"></p-sortIcon>
            </th>
            <th pSortableColumn="created" class="text-xs uppercase">
              {{ t("queried_date") }}
              <p-sortIcon field="created"></p-sortIcon>
            </th>
            <th class="text-xs uppercase text-center"></th>
          </tr>
        </ng-template>
        <ng-template #body let-entry>
          <tr class="hover:bg-grey-lighter/50 transition-colors">
            <td>
              <span class="font-medium text-sm text-grey-dark">{{
                entry.engagementName
              }}</span>
            </td>
            <td>
              <span
                class="text-xs font-mono px-1.5 py-0.5 rounded bg-grey-lighter text-grey-default"
                >{{ entry.jobCode }}</span
              >
            </td>
            <td>
              <span class="text-sm font-mono text-grey-dark">{{
                entry.vatNumber
              }}</span>
            </td>
            <td>
              <span class="text-sm font-mono text-grey-dark">{{
                entry.iban
              }}</span>
            </td>
            <td class="text-center">
              <div class="flex items-center justify-center gap-2">
                <span
                  *ngIf="entry.datasetRequested"
                  class="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium rounded bg-grey-lighter text-grey-dark"
                >
                  <span class=""></span>
                  Dataset
                </span>
                <span
                  *ngIf="entry.powerBiRequested"
                  class="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium rounded bg-grey-lighter text-grey-dark"
                >
                  <span class=""></span>
                  Power BI
                </span>
              </div>
            </td>
            <td>
              <span
                class="inline-flex items-center px-2.5 py-1 text-xs font-semibold rounded-full"
                [ngClass]="getStatusClass(entry.status)"
              >
                {{ entry.status }}
              </span>
            </td>
            <td>
              <span class="text-sm text-grey-default">{{
                entry.created | date: "yyyy.MM.dd HH:mm"
              }}</span>
            </td>
            <td class="text-center">
              <a
                [routerLink]="['/status-monitor/transactions', entry.id]"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-orange-default hover:text-white hover:bg-orange-default border border-orange-default rounded-lg transition-colors"
              >
                <span class="icon-view-fill text-xs"></span>
                {{ t("details") }}
              </a>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td [attr.colspan]="8">
              <div
                class="flex flex-col items-center justify-center py-12 text-center"
              >
                <span
                  class="icon-time-fill text-4xl text-grey-light mb-3"
                ></span>
                <p class="text-sm text-grey-medium">
                  {{ loading ? t("loading") : t("empty_message") }}
                </p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
